import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import { capitalizeWords } from '../../Utility/Utility';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import LiveSupportWidget from './LiveSupportWidget';
import NotificationBell from './NotificationBell';
import { useSubscriptionFlag } from '../Subscription/flag/subscriptionFlagStore';
import { FREE_USER_TEXT, isFreeUser } from '../Subscription/flag/flagReasons';
import '../Subscription/Subscription.css';

const Header = () => {
  // Free User Access employees (subscription-flag EXEMPT): show a "Free
  // User" badge next to the panel title on every screen, and hide
  // "UPI Mandate" (no AutoPay for them).
  const { flag: subscriptionFlag } = useSubscriptionFlag();
  const freeUser = isFreeUser(subscriptionFlag);

  // Note: NotificationBell manages its own open/close state (like
  // LiveSupportWidget below) instead of through this dropdownOpen map.
  const [dropdownOpen, setDropdownOpen] = useState({
    search: false,
    messages: false,
    user: false
  });

  const dropdownRefs = {
    search: useRef(null),
    messages: useRef(null),
    user: useRef(null)
  };

  const toggleDropdown = (key) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleClickOutside = (event) => {
    const dropdownKeys = Object.keys(dropdownRefs);
    dropdownKeys.forEach((key) => {
      if (dropdownRefs[key].current && !dropdownRefs[key].current.contains(event.target)) {
        setDropdownOpen((prev) => ({ ...prev, [key]: false }));
      }
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setDropdownOpen({
        search: false,
        messages: false,
        user: false
      });
    }
  };



  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const navigate = useNavigate();
  const handleLogOut = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of your account!",
      icon: "warning",
      allowOutsideClick: false, // Add this line
      showCancelButton: true,
      confirmButtonColor: "#32438e",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log me out!",
      cancelButtonText: "No, cancel",
    });

    if (result.isConfirmed) {
      localStorage.clear();
      navigate("/");
      Swal.fire("Logged out!", "You have been logged out.", "success");
    }
  };


  // Channel details (used only for the header's short channel name) are
  // fetched once at login and cached in localStorage (Login.jsx) — Header
  // just reads the cache instead of calling GetChannelById itself, since it
  // remounts on every page (no shared layout wraps the routes).
  const [channelDetails] = useState(() => {
    const cached = localStorage.getItem("ChannelDetails");
    return cached ? JSON.parse(cached) : null;
  });

  const handleSidebarToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    window.dispatchEvent(new Event("panel-sidebar-toggle"));
  };

  return (
    <>

      <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
        <div className="container-fluid">
          <nav className="navbar navbar-header-left navbar-expand-lg navbar-form nav-search p-0 ">
            <div className="name-user panel-title-shell">
              <button
                type="button"
                className="panel-header-menu"
                aria-label="Toggle sidebar"
                onClick={handleSidebarToggle}
              >
                <span />
                <span />
                <span />
              </button>

              <span className="panel-title-rule" aria-hidden="true" />

              <h5>
                {channelDetails?.shortChannelName || ""} {(localStorage.getItem("Roles"))} Panel
                {freeUser && (
                  <span className="sub-free-badge" title={FREE_USER_TEXT}>
                    <i className="bx bx-gift" /> Free User
                  </span>
                )}
              </h5>
            </div>
            {/* <div className="input-group">
              <div className="input-group-prepend">
                <button type="submit" className="btn btn-search pe-1">
                  <i className="fa fa-search search-icon" />
                </button>
              </div>
              <input type="text" placeholder="Search ..." className="form-control" />
            </div> */}
          </nav>
          <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
            <li className="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none" ref={dropdownRefs.search}>
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                role="button"
                aria-expanded={dropdownOpen.search}
                onClick={() => toggleDropdown('search')}
              >
                <i className="fa fa-search" />
              </Link>
              <ul className={`dropdown-menu dropdown-search animated fadeIn ${dropdownOpen.search ? 'show' : ''}`}>
                {/* <form className="navbar-left navbar-form nav-search">
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="Search ..."
                      className="form-control"
                    />
                  </div>
                </form> */}
              </ul>
            </li>


            <NotificationBell />

            <LiveSupportWidget />

            <li className="nav-item topbar-user dropdown hidden-caret submenu" ref={dropdownRefs.user}>
              <Link
                className="dropdown-toggle profile-pic"
                to="#"
                aria-expanded={dropdownOpen.user}
                onClick={() => toggleDropdown('user')}
              >
                {/* <div className="avatar-sm">
                  <img
                    src="assets/images/profile.png"
                    alt="..."
                    className="avatar-img1 rounded-circle"
                  />
                </div> */}
                <span className="profile-username">
                  <h6>{localStorage.getItem("FullName")?.charAt(0)}</h6>
                  <label>
                    <strong>
                      <span>{capitalizeWords(localStorage.getItem("FullName"))}</span>
                      <img src="assets/images/icons/arrowprofile.svg" alt="" />
                    </strong>
                    <p className='uppercase-header'>{(localStorage.getItem("Roles"))}</p></label>
                </span>
              </Link>
              <ul className={`dropdown-menu dropdown-user animated fadeIn ${dropdownOpen.user ? 'show' : ''}`}>
                <div
                  className="scroll-wrapper dropdown-user-scroll scrollbar-outer"
                  style={{ position: "relative" }}
                >
                  <div
                    className="dropdown-user-scroll scrollbar-outer scroll-content"
                    style={{
                      height: "auto",
                      marginBottom: 0,
                      marginRight: 0,
                      maxHeight: "262.828px"
                    }}
                  >
                    <li>
                      {/* Also here, because the panel title (and its badge)
                          is hidden on very small screens. */}
                      {freeUser && (
                        <span
                          className="sub-free-badge sub-free-badge--menu"
                          title={FREE_USER_TEXT}
                        >
                          <i className="bx bx-gift" /> Free User
                        </span>
                      )}
                      <Link className="dropdown-item" to="/profile">
                        <i class="bx bx-user-circle icon"></i> My Profile
                      </Link>

                      <Link className="dropdown-item" to="/change-password">
                        <i class="bx bx-lock-alt icon"></i>     Change Password
                      </Link>
                      <Link className="dropdown-item" to="/change-phone-no">
                        <i class="bx bx-phone icon"></i>    Change Phone No
                      </Link>
                      <Link className="dropdown-item" to="/change-email">
                        <i class="bx bx-envelope icon"></i>    Change Email
                      </Link>
                      <Link to="/security" className="dropdown-item">
                        <FontAwesomeIcon icon={faShieldAlt} />
                        Security
                      </Link>
                      <Link className="dropdown-item" to="/ai-credit-usage">
                        <i class="bx bx-wallet icon"></i>    AI Credit Usage
                      </Link>
                      {!freeUser && (
                        <Link className="dropdown-item" to="/autopay-mandate">
                          <i class="bx bx-qr-scan icon"></i>    UPI Mandate
                        </Link>
                      )}

                      {/* <div className="dropdown-divider" /> */}
                      <Link className="dropdown-item" href="#" onClick={handleLogOut}>
                        <i class="bx bx-log-out icon"></i>    Logout
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </li>
          </ul>
        </div>
      </nav>


    </>
  )
}

export default Header